import { createSlice } from "@reduxjs/toolkit";
import {
  login,
  checkEmailAlreadyExists,
  isSignoutModalOpen,
  VerifyOtp,
  sendEmailOtp
} from "src/thunks/auth";

const initialState = {
  loading: false,
  isAuth: false,
  token: "",
  verifyToken: "",
  userDetails: "",
  isEmailExistsLoading: false,
  loginLoading: false,
  sendEmailOtpLoading: false,
  error: "",
  signoutModelOpenFlag: "",
};

const authSlice = createSlice({
  name: "authSlice",
  reducers: {

  },
  initialState,

  extraReducers: (builder) => {
    builder

      /** Check email already exist or not --------------------- **/
      .addCase(checkEmailAlreadyExists.pending, (state, action) => {
        state.isEmailExistsLoading = true;
      })
      .addCase(checkEmailAlreadyExists.fulfilled, (state, action) => {
        state.isEmailExistsLoading = false;
      })
      .addCase(checkEmailAlreadyExists.rejected, (state, action) => {
        state.isEmailExistsLoading = false;
      })

      /** Send OTP ------------------------ **/
      .addCase(sendEmailOtp.pending, (state, action) => {
        state.sendEmailOtpLoading = true;
      })
      .addCase(sendEmailOtp.fulfilled, (state, action) => {
        state.sendEmailOtpLoading = false;
      })
      .addCase(sendEmailOtp.rejected, (state, action) => {
        state.sendEmailOtpLoading = false;
      })

      /** Login ----------------------------- **/
      .addCase(login.pending, (state, action) => {
        state.loginLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loginLoading = false;
        state.isAuth = true;
        state.error = "";
        state.token = action.payload.token;
        state.userDetails = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.isAuth = false;
        state.loginLoading = false;
      })

      //signout flag
      .addCase(isSignoutModalOpen, (state, action) => {
        state.signoutModelOpenFlag = action.payload; // networkConnectivity
      })

      /** To verify entered OTP ------------------------ **/
      .addCase(VerifyOtp.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(VerifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.verifyToken = action.payload;
      })
      .addCase(VerifyOtp.rejected, (state, action) => {
        state.isAuth = false;
        state.loading = false;
        state.error = action?.payload?.response?.data?.detail || "";
      });

  },
});

export default authSlice;
